import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { app } from './firebase';
// import { fetchUserData } from './firestore';

const auth = getAuth(app);

export const signInWithEmail = async (email, password) => {
    try {
      
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
  
      const userId = userCredential.user.uid;
      console.log('User signed in:', userId);
  
      return userId;
      
    } catch (error) {
      console.error('Error signing in:', error.message);
      throw error;
    }
  };

  export const createAttyAcct = async (email, password) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const fbuid = userCredential.user.uid;
  
      return fbuid;
  
    } catch (error) {
      console.error("❌ Attorney Account not created:", error.message);
      alert("Attorney Account not created. Check email and try again.");
      throw error; // Re-throw the error to handle it in the calling function
    }
  };


export const logOut = async () => {
  try {
    await signOut(auth);
    console.log('User logged out');
  } catch (error) {
    console.error('Error logging out:', error.message);
    throw error;
  }
};

export const verifyPasswordWithEmail = async (email, password) => {
  
  const user = auth.currentUser;

  if (!user) {
      console.error("❌ No user is currently logged in.");
      return false;
  }

  try {
      // 🔹 Create the credential with the user's email and entered password
      const credential = EmailAuthProvider.credential(email, password);
      
      // 🔹 Reauthenticate the user with the provided password
      await reauthenticateWithCredential(user, credential);
      
      console.log("✅ Password verification successful");
      return true;
  } catch (error) {
      console.error("❌ Password verification failed", error);
      return false;
  }
};
